import 'css-chunksrc/client/common/milestoneIcon/styles.scss';export default {
  "completed": "_completed_nk6nk_1",
  "unscheduled": "_unscheduled_nk6nk_5"
};